module.exports = __webpack_public_path__ + "static/media/dm.5966a127.svg";